import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ChevronUp, ChevronDown, Search, BookOpen, RefreshCw, Users, Clock, Calendar, X, Download, NotebookPen, UserPlus } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { Button } from "../../components/ui/button";
import { toast } from "react-toastify";
import UserSelectionModal from "../training/UserSelectionModal";
import TrainingEditModal from "../training/TrainingEditModal";

const API_BASE_URL = `${process.env.REACT_APP_API_URL.replace(/\/$/, '')}/api/userqualification/`;
const TRAINING_ASSIGNMENTS_URL = `${process.env.REACT_APP_API_URL.replace(/\/$/, '')}/api/user-training-assignments/`;
const TRAINING_CENTERS_URL = `${process.env.REACT_APP_API_URL.replace(/\/$/, '')}/api/training-center-qualifications/`;
const API_BASE = `${process.env.REACT_APP_API_URL?.replace(/\/$/, "") || ""}/api`;

const CertificateExp = () => {
  const [searchParams] = useSearchParams();
  const [certificates, setCertificates] = useState([]);
  const [filteredCertificates, setFilteredCertificates] = useState([]);
  
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortField, setSortField] = useState('expiring_date');
  const [sortDirection, setSortDirection] = useState('asc');
  const [currentPage, setCurrentPage] = useState(1);
  const [filterOption, setFilterOption] = useState(searchParams.get('filter') || 'all');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCertificate, setSelectedCertificate] = useState(null);
  const [trainingCenters, setTrainingCenters] = useState([]);
  const [availableCenters, setAvailableCenters] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [searchTermModal, setSearchTermModal] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [showUserSelectionModal, setShowUserSelectionModal] = useState(false);
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [showNoTrainingModal, setShowNoTrainingModal] = useState(false);
  const [showTrainingDetailsModal, setShowTrainingDetailsModal] = useState(false); // Pozostawiam dla kompatybilności
  const [trainingDetails, setTrainingDetails] = useState({
    training: "",
    trainingId: null,
    centerId: null,
    startTime: "09:00",
    endTime: "16:00",
    description: "",
    requiredItems: "",
    trainingDate: new Date(),
  });
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedCertificateNames, setSelectedCertificateNames] = useState([]);
  const [selectedCertificateIds, setSelectedCertificateIds] = useState([]);
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const [certificateDropdownOpen, setCertificateDropdownOpen] = useState(false);
  const [userSearchTerm, setUserSearchTerm] = useState("");
  const [certificateSearchTerm, setCertificateSearchTerm] = useState("");
  const [showExportModal, setShowExportModal] = useState(false);
  const [trainingFilter, setTrainingFilter] = useState('all');
  const [dateRange, setDateRange] = useState({ startDate: '', endDate: '' });
  const [showTrainingEditModal, setShowTrainingEditModal] = useState(false);
  const [trainingEditData, setTrainingEditData] = useState(null);
  const [selectedUsersForTraining, setSelectedUsersForTraining] = useState([]);
  const [showMultipleTrainingsModal, setShowMultipleTrainingsModal] = useState(false);
  const [trainingGroups, setTrainingGroups] = useState([]);
  const [currentTrainingGroupIndex, setCurrentTrainingGroupIndex] = useState(0);
  const [showExistingTrainingsModal, setShowExistingTrainingsModal] = useState(false);
  const [existingTrainings, setExistingTrainings] = useState([]);
  const [selectedExistingTraining, setSelectedExistingTraining] = useState(null);
  const [allTrainings, setAllTrainings] = useState([]);

  useEffect(() => {
    fetchCertificates();
    fetchTrainingCenters();
    fetchAllTrainings();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.user-select-dropdown') && !event.target.closest('.certificate-select-dropdown')) {
        setUserDropdownOpen(false);
        setCertificateDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    filterAndSortCertificates();
  }, [certificates, searchTerm, sortField, sortDirection, filterOption, selectedUsers, selectedCertificateNames, trainingFilter, dateRange]);

  const fetchCertificates = async () => {
    try {
      const token = localStorage.getItem('access_token');

      const certResponse = await axios.get(API_BASE_URL, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log('Fetched certificate data:', certResponse.data);

      const currentDate = new Date();
      const formattedCertificates = certResponse.data.map(qual => {
        const expiryDate = qual.expiry_date || null;
        let daysStatus = null;
        if (expiryDate) {
          const timeDiff = new Date(expiryDate).getTime() - currentDate.getTime();
          daysStatus = Math.floor(timeDiff / (1000 * 3600 * 24));
        }
        return {
          id: qual.id,
          name: qual.user_full_name || 'N/A',
          expiring_date: qual.expiry_date || 'N/A',
          certificate_name: qual.qualification_type_data?.name || 'N/A',
          qualification_type_id: qual.qualification_type_data?.id || null,
          user_id: qual.user || null,
          daysStatus: daysStatus,
          certificate_file: qual.certificate_file || null,
        };
      });

      setCertificates(formattedCertificates);
      setFilteredCertificates(formattedCertificates);

      

    } catch (error) {
      console.error('Error fetching data:', error);
      setError(error.response?.data?.detail || 'Failed to fetch certificates.');
    }
  };

  const fetchTrainingCenters = async () => {
    try {
      const token = localStorage.getItem('access_token');
      const response = await axios.get(TRAINING_CENTERS_URL, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log('Fetched training centers:', response.data);
      setTrainingCenters(response.data);
    } catch (error) {
      console.error('Error fetching training centers:', error);
    }
  };

  const fetchAllTrainings = async () => {
    try {
      const token = localStorage.getItem("access_token");
      const userData = JSON.parse(localStorage.getItem("user") || "{}");
      const companyId = userData.company;
      
      const response = await axios.get(`${API_BASE}/trainings/`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { company: companyId }
      });
      
      console.log('Fetched all trainings:', response.data);
      setAllTrainings(response.data);
    } catch (error) {
      console.error('Error fetching all trainings:', error);
    }
  };

  const getTrainingInfo = (cert) => {
    if (!cert.user_id || !cert.qualification_type_id) {
      return 'No training planned';
    }

    // Znajdź przyszłe treningi dla tego użytkownika i qualification_type
    const today = new Date();
    const userTrainings = allTrainings.filter(training => {
      const startDate = new Date(training.start_date);
      const hasUser = training.users && training.users.includes(cert.user_id);
      const correctQualification = training.training_center_qualification_data?.qualification_type?.qualification_type_data?.id === cert.qualification_type_id;
      
      return startDate > today && hasUser && correctQualification;
    });

    if (userTrainings.length > 0) {
      // Sortuj po dacie i weź najbliższy
      userTrainings.sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
      const nextTraining = userTrainings[0];
      const startDate = new Date(nextTraining.start_date);
      
      return `Scheduled for ${startDate.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      })}`;
    }

    return 'No training planned';
  };

  const getTrainingDate = (cert) => {
    if (!cert.user_id || !cert.qualification_type_id) {
      return null;
    }

    // Znajdź przyszłe treningi dla tego użytkownika i qualification_type
    const today = new Date();
    const userTrainings = allTrainings.filter(training => {
      const startDate = new Date(training.start_date);
      const hasUser = training.users && training.users.includes(cert.user_id);
      const correctQualification = training.training_center_qualification_data?.qualification_type?.qualification_type_data?.id === cert.qualification_type_id;
      
      return startDate > today && hasUser && correctQualification;
    });

    if (userTrainings.length > 0) {
      // Sortuj po dacie i weź najbliższy
      userTrainings.sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
      return new Date(userTrainings[0].start_date);
    }

    return null;
  };

  const openTrainingDetailsModal = (cert) => {
    if (!cert.user_id || !cert.qualification_type_id) {
      return;
    }

    // Znajdź przyszłe treningi dla tego użytkownika i qualification_type
    const today = new Date();
    const userTrainings = allTrainings.filter(training => {
      const startDate = new Date(training.start_date);
      const hasUser = training.users && training.users.includes(cert.user_id);
      const correctQualification = training.training_center_qualification_data?.qualification_type?.qualification_type_data?.id === cert.qualification_type_id;
      
      return startDate > today && hasUser && correctQualification;
    });

    if (userTrainings.length > 0) {
      // Sortuj po dacie i weź najbliższy
      userTrainings.sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
      const nextTraining = userTrainings[0];
      
      // Otwórz TrainingEditModal w trybie edycji
      setTrainingEditData({
        ...nextTraining,
        isNew: false // Oznacza tryb edycji
      });
      setShowTrainingEditModal(true);
    }
  };

  const handleSort = (field) => {
    const newDirection = sortField === field && sortDirection === 'asc' ? 'desc' : 'asc';
    setSortField(field);
    setSortDirection(newDirection);
    setCurrentPage(1);
  };

  const filterAndSortCertificates = () => {
    let result = [...certificates];

    // Filter certificates, applying all conditions conjunctively
    result = result.filter(cert => {
      let matchesFilterOption = true;
      let matchesSelectedUsers = true;
      let matchesSelectedCertificates = true;
      let matchesSearchTerm = true;
      let matchesTrainingFilter = true;
      let matchesDateRange = true;

      // 1. Filter by select option
      switch (filterOption) {
        case 'valid':
          matchesFilterOption = cert.daysStatus !== null && cert.daysStatus >= 0;
          break;
        case 'expired':
          matchesFilterOption = cert.daysStatus !== null && cert.daysStatus < 0;
          break;
        case 'next30':
          matchesFilterOption = cert.daysStatus !== null && cert.daysStatus >= 0 && cert.daysStatus <= 30;
          break;
        case 'next60':
          matchesFilterOption = cert.daysStatus !== null && cert.daysStatus >= 0 && cert.daysStatus <= 60;
          break;
        case 'next90':
          matchesFilterOption = cert.daysStatus !== null && cert.daysStatus >= 0 && cert.daysStatus <= 90;
          break;
        default:
          break;
      }

      // 2. Filter by selected users
      if (selectedUsers.length > 0) {
        matchesSelectedUsers = selectedUsers.includes(cert.name);
      }

      // 3. Filter by selected certificate names
      if (selectedCertificateNames.length > 0) {
        matchesSelectedCertificates = selectedCertificateNames.includes(cert.certificate_name);
      }

      // 4. Filter by search term
      if (searchTerm.trim() !== '') {
        const lowerCaseSearchTerm = searchTerm.toLowerCase();
        matchesSearchTerm =
          cert.name.toLowerCase().includes(lowerCaseSearchTerm) ||
          cert.certificate_name.toLowerCase().includes(lowerCaseSearchTerm) ||
          cert.expiring_date.toLowerCase().includes(lowerCaseSearchTerm);
      }

      // 5. Filter by training status
      if (trainingFilter !== 'all') {
        const trainingInfo = getTrainingInfo(cert);
        if (trainingFilter === 'planned') {
          matchesTrainingFilter = trainingInfo.startsWith('Scheduled');
        } else if (trainingFilter === 'not_planned') {
          matchesTrainingFilter = trainingInfo === 'No training planned';
        }
      }

      // 6. Filter by date range
      if (dateRange.startDate || dateRange.endDate) {
        const expiryDate = cert.expiring_date && cert.expiring_date !== 'N/A' ? new Date(cert.expiring_date) : null;
        if (expiryDate) {
          if (dateRange.startDate) {
            const startDate = new Date(dateRange.startDate);
            matchesDateRange = expiryDate >= startDate;
          }
          if (dateRange.endDate && matchesDateRange) {
            const endDate = new Date(dateRange.endDate);
            matchesDateRange = expiryDate <= endDate;
          }
        } else {
          matchesDateRange = false;
        }
      }

      return (
        matchesFilterOption &&
        matchesSelectedUsers &&
        matchesSelectedCertificates &&
        matchesSearchTerm &&
        matchesTrainingFilter &&
        matchesDateRange
      );
    });

    // Sorting
    result.sort((a, b) => {
      let compareA, compareB, compareDateA, compareDateB;

      switch (sortField) {
        case 'name':
          compareA = a.name.toLowerCase();
          compareB = b.name.toLowerCase();
          compareDateA = a.expiring_date || '9999-12-31';
          compareDateB = b.expiring_date || '9999-12-31';
          break;
        case 'certificate_name':
          compareA = a.certificate_name.toLowerCase() || '';
          compareB = b.certificate_name.toLowerCase() || '';
          compareDateA = a.expiring_date || '9999-12-31';
          compareDateB = b.expiring_date || '9999-12-31';
          break;
        case 'expiring_date':
          compareA = a.expiring_date || '9999-12-31';
          compareB = b.expiring_date || '9999-12-31';
          break;
        case 'daysStatus':
          compareA = a.daysStatus ?? Infinity;
          compareB = b.daysStatus ?? Infinity;
          break;
        case 'training':
          const trainingDateA = getTrainingDate(a);
          const trainingDateB = getTrainingDate(b);
          if (!trainingDateA && !trainingDateB) {
            compareA = 0;
            compareB = 0;
          } else if (!trainingDateA) {
            compareA = sortDirection === 'asc' ? Infinity : -Infinity;
            compareB = trainingDateB.getTime();
          } else if (!trainingDateB) {
            compareA = trainingDateA.getTime();
            compareB = sortDirection === 'asc' ? Infinity : -Infinity;
          } else {
            compareA = trainingDateA.getTime();
            compareB = trainingDateB.getTime();
          }
          break;
        default:
          compareA = a[sortField]?.toString().toLowerCase() || '';
          compareB = b[sortField]?.toString().toLowerCase() || '';
      }

      if (sortField === 'daysStatus' || sortField === 'training') {
        if (compareA === compareB) return 0;
        return sortDirection === 'asc' ? (compareA < compareB ? -1 : 1) : (compareA > compareB ? -1 : 1);
      }

      let comparison = compareA.localeCompare(compareB);
      if (comparison === 0 && (sortField === 'name' || sortField === 'certificate_name')) {
        comparison = compareDateA.localeCompare(compareDateB);
      }

      return sortDirection === 'asc' ? comparison : -comparison;
    });

    setFilteredCertificates(result);
  };

  const handleSelectAll = () => {
    const allCertificateIds = filteredCertificates.map(cert => cert.id);
    const allSelected = allCertificateIds.every(id => selectedCertificateIds.includes(id));

    if (allSelected) {
      // Deselect all filtered certificates
      setSelectedCertificateIds([]);
    } else {
      // Select all filtered certificates
      setSelectedCertificateIds(allCertificateIds);
    }
  };

  const handleCheckboxChange = (certId) => {
    setSelectedCertificateIds(prev => 
      prev.includes(certId)
        ? prev.filter(id => id !== certId)
        : [...prev, certId]
    );
  };

  const handleDownloadCertificates = async () => {
    console.log("Download button clicked");
    console.log("Selected certificate IDs:", selectedCertificateIds);
    
    if (selectedCertificateIds.length === 0) {
      toast.error("Please select certificates to download");
      return;
    }

    try {
      const token = localStorage.getItem('access_token');
      const selectedCerts = certificates.filter(cert => selectedCertificateIds.includes(cert.id));
      
      console.log("All certificates:", certificates);
      console.log("Selected certificates:", selectedCerts);
      
      // Group certificates by user
      const userCertificates = {};
      selectedCerts.forEach(cert => {
        if (!userCertificates[cert.user_id]) {
          userCertificates[cert.user_id] = {
            userName: cert.name,
            certificates: []
          };
        }
        userCertificates[cert.user_id].certificates.push(cert);
      });

      // Create ZIP file with JSZip
      const JSZip = (await import('jszip')).default;
      const zip = new JSZip();

      let downloadCount = 0;
      const totalFiles = selectedCerts.length;

      for (const [userId, userData] of Object.entries(userCertificates)) {
        // Sanitize folder name - allow Polish characters
        const sanitizeFolderName = (str) => (str || 'Unknown').replace(/[^a-zA-Z0-9ąćęłńóśźżĄĆĘŁŃÓŚŹŻ\s]/g, '').replace(/\s+/g, '_');
        const userFolder = zip.folder(sanitizeFolderName(userData.userName));
        
        for (const cert of userData.certificates) {
          console.log("Processing certificate:", cert);
          console.log("Certificate file field:", cert.certificate_file);
          
          if (cert.certificate_file) {
            try {
              // Build full URL if certificate_file is a relative path
              const fileUrl = cert.certificate_file.startsWith('http') 
                ? cert.certificate_file 
                : `${process.env.REACT_APP_API_URL.replace(/\/$/, '')}${cert.certificate_file.startsWith('/') ? '' : '/'}${cert.certificate_file}`;
              
              // Download the certificate file
              const response = await axios.get(fileUrl, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob'
              });

              // Get file extension from original file or default to pdf
              const originalFilename = cert.certificate_file.split('/').pop() || '';
              const extension = originalFilename.includes('.')
                ? originalFilename.split('.').pop().toLowerCase()
                : 'pdf';

              // Generate proper filename: Imię_Nazwisko_NazwaKwalifikacji_DataWażności.ext
              const sanitize = (str) => (str || '').replace(/[^a-zA-Z0-9ąćęłńóśźżĄĆĘŁŃÓŚŹŻ]/g, '_').replace(/_+/g, '_').replace(/^_|_$/g, '');
              const userName = sanitize(cert.name || userData.userName);
              const qualificationName = sanitize(cert.certificate_name || 'Certificate');
              const expiryDate = cert.expiring_date ? cert.expiring_date.replace(/-/g, '') : 'NoDate';

              const filename = `${userName}_${qualificationName}_${expiryDate}.${extension}`;

              userFolder.file(filename, response.data);
              downloadCount++;
            } catch (error) {
              console.warn(`Failed to download certificate for ${cert.name}:`, error);
              // Continue with other files even if one fails
            }
          }
        }
      }

      if (downloadCount === 0) {
        toast.error("No certificate files found to download");
        return;
      }

      // Generate and download ZIP
      const content = await zip.generateAsync({ type: "blob" });
      const url = window.URL.createObjectURL(content);
      const link = document.createElement("a");
      link.href = url;
      // Generate descriptive ZIP filename
      const userNames = Object.values(userCertificates).map(u => u.userName.split(' ')[0]).slice(0, 3).join('_');
      const dateStr = new Date().toISOString().split('T')[0];
      link.download = `Certificates_${userNames}${Object.keys(userCertificates).length > 3 ? '_and_others' : ''}_${dateStr}.zip`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      toast.success(`Downloaded ${downloadCount} certificate(s) successfully`);
      
      // Clear selection after successful download
      setSelectedCertificateIds([]);
      
    } catch (error) {
      console.error('Error downloading certificates:', error);
      toast.error("Failed to download certificates");
    }
  };

  // Utility to get user_ids from selected certificates
  const getSelectedUserIds = () => {
    return [...new Set(
      certificates
        .filter(cert => selectedCertificateIds.includes(cert.id))
        .map(cert => cert.user_id)
    )];
  };

  // Group users by qualification_type from selected certificates
  const groupUsersByQualificationType = () => {
    const selectedCerts = certificates.filter(cert => selectedCertificateIds.includes(cert.id));
    const groups = {};
    
    selectedCerts.forEach(cert => {
      const qualificationTypeId = cert.qualification_type_id;
      if (!groups[qualificationTypeId]) {
        groups[qualificationTypeId] = {
          qualification_type_id: qualificationTypeId,
          certificate_name: cert.certificate_name,
          users: [],
          centers: []
        };
      }
      
      if (!groups[qualificationTypeId].users.includes(cert.user_id)) {
        groups[qualificationTypeId].users.push(cert.user_id);
      }
    });

    // Add available training centers for each group
    Object.keys(groups).forEach(qualTypeId => {
      const centersForQualification = trainingCenters.filter(centerQual => 
        centerQual.qualification_type?.qualification_type_data?.id === parseInt(qualTypeId)
      );
      groups[qualTypeId].centers = centersForQualification;
      groups[qualTypeId].qualificationType = centersForQualification[0]?.qualification_type;
      groups[qualTypeId].trainingNumber = centersForQualification[0]?.qualification_type?.training_number;
    });

    return Object.values(groups);
  };

  const formatDaysStatus = (daysStatus) => {
    if (daysStatus === null) return 'N/A';
    if (daysStatus > 0) return `Expires in ${daysStatus} days`;
    if (daysStatus < 0) return `Expired ${Math.abs(daysStatus)} days ago`;
    return 'Expires today';
  };

  const getRowBackgroundColor = (daysStatus) => {
    if (daysStatus === null) {
      return { base: 'bg-white', hover: 'hover:bg-brand-50' };
    }
    if (daysStatus < 0) {
      return { base: 'bg-red-50', hover: 'hover:bg-red-100' };
    }
    if (daysStatus <= 30) {
      return { base: 'bg-brand-50', hover: 'hover:bg-brand-100' };
    }
    if (daysStatus <= 60) {
      return { base: 'bg-yellow-50', hover: 'hover:bg-yellow-100' };
    }
    return { base: 'bg-green-50', hover: 'hover:bg-green-100' };
  };

  const totalPages = Math.ceil(filteredCertificates.length / itemsPerPage);
  const paginatedCertificates = filteredCertificates.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const getVisiblePages = () => {
    const maxVisiblePages = 5;
    const pages = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, currentPage + 2);

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  const openModal = (certificate) => {
    console.log('Opening modal for certificate:', certificate);
    setSelectedCertificate(certificate);
    
    // Sprawdź czy mamy zaznaczone certyfikaty
    if (selectedCertificateIds.length > 1) {
      // Grupuj użytkowników według qualification_type
      const groups = groupUsersByQualificationType();
      console.log('Training groups:', groups);
      
      // Sprawdź czy wszystkie grupy mają dostępne centra szkoleniowe
      const groupsWithoutCenters = groups.filter(group => group.centers.length === 0);
      if (groupsWithoutCenters.length > 0) {
        setShowNoTrainingModal(true);
        return;
      }
      
      if (groups.length === 1) {
        // Wszyscy użytkownicy mają ten sam typ kwalifikacji
        const group = groups[0];
        setTrainingEditData({
          isNew: true,
          qualificationType: group.qualificationType,
          trainingNumber: group.trainingNumber,
          users: group.users
        });
        setShowTrainingEditModal(true);
      } else {
        // Różne typy kwalifikacji - pokaż pytanie o wiele treningów
        setTrainingGroups(groups);
        setShowMultipleTrainingsModal(true);
      }
    } else {
      // Single certificate logic (bez zmian)
      const centersForQualification = trainingCenters.filter(centerQual => 
        centerQual.qualification_type?.qualification_type_data?.id === certificate.qualification_type_id
      );
      
      console.log('Available centers for qualification:', centersForQualification);
      
      if (centersForQualification.length === 0) {
        setShowNoTrainingModal(true);
      } else {
        const qualificationType = centersForQualification[0]?.qualification_type;
        const trainingNumber = qualificationType?.training_number;
        
        setTrainingEditData({
          isNew: true,
          qualificationType: qualificationType,
          trainingNumber: trainingNumber,
          users: [certificate.user_id]
        });
        
        setShowTrainingEditModal(true);
      }
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setShowNoTrainingModal(false);
    setSelectedCertificate(null);
    setSelectedCenter(null);
    setAvailableCenters([]);
    setSelectedUserIds([]);
    setSearchTermModal('');
    setShowDropdown(false);
    setTrainingDetails({
      training: "",
      trainingId: null,
      centerId: null,
      startTime: "09:00",
      endTime: "16:00",
      description: "",
      requiredItems: "",
      trainingDate: new Date(),
    });
  };

  const closeTrainingEditModal = () => {
    setShowTrainingEditModal(false);
    setTrainingEditData(null);
    setSelectedCertificate(null);
    setSelectedUsersForTraining([]);
  };

  const handleTrainingEditSuccess = () => {
    console.log('handleTrainingEditSuccess called');
    console.log('currentTrainingGroupIndex:', currentTrainingGroupIndex);
    console.log('trainingGroups.length:', trainingGroups.length);
    console.log('trainingGroups:', trainingGroups);
    
    fetchCertificates(); // Odśwież dane po utworzeniu treningu
    fetchAllTrainings(); // Odśwież listę treningów
    
    // Sprawdź czy są kolejne grupy do przetworzenia
    if (currentTrainingGroupIndex + 1 < trainingGroups.length) {
      console.log('Moving to next training group');
      // Otwórz następny modal treningowy
      const nextIndex = currentTrainingGroupIndex + 1;
      setCurrentTrainingGroupIndex(nextIndex);
      
      const nextGroup = trainingGroups[nextIndex];
      console.log('Next group:', nextGroup);
      
      setTrainingEditData({
        isNew: true,
        qualificationType: nextGroup.qualificationType,
        trainingNumber: nextGroup.trainingNumber,
        users: nextGroup.users,
        isMultipleTrainings: true,
        currentTrainingIndex: nextIndex + 1,
        totalTrainings: trainingGroups.length
      });
      
      // Nie zamykaj obecnego modalu, tylko ustaw nowe dane
      toast.success(`Training ${nextIndex + 1} of ${trainingGroups.length} scheduled successfully!`);
    } else {
      console.log('All trainings completed, closing modal');
      // Wszystkie treningi zostały utworzone
      closeTrainingEditModal();
      setTrainingGroups([]);
      setCurrentTrainingGroupIndex(0);
      setSelectedCertificateIds([]); // Wyczyść zaznaczenie
      toast.success("All trainings scheduled successfully!");
    }
  };

  const startMultipleTrainings = () => {
    setShowMultipleTrainingsModal(false);
    setCurrentTrainingGroupIndex(0);
    
    // Rozpocznij od pierwszej grupy
    const firstGroup = trainingGroups[0];
    setTrainingEditData({
      isNew: true,
      qualificationType: firstGroup.qualificationType,
      trainingNumber: firstGroup.trainingNumber,
      users: firstGroup.users,
      isMultipleTrainings: true,
      currentTrainingIndex: 1,
      totalTrainings: trainingGroups.length
    });
    
    setShowTrainingEditModal(true);
  };

  const cancelMultipleTrainings = () => {
    setShowMultipleTrainingsModal(false);
    setTrainingGroups([]);
    setCurrentTrainingGroupIndex(0);
    setSelectedCertificate(null);
  };

  const openExistingTrainingsModal = (certificate) => {
    console.log('Opening existing trainings modal for certificate:', certificate);
    setSelectedCertificate(certificate);
    
    // Sprawdź czy mamy zaznaczone certyfikaty
    if (selectedCertificateIds.length > 1) {
      // Grupuj użytkowników według qualification_type
      const groups = groupUsersByQualificationType();
      console.log('Training groups for existing trainings:', groups);
      
      // Na razie obsłużmy tylko przypadek gdy wszyscy mają ten sam qualification_type
      if (groups.length === 1) {
        const group = groups[0];
        fetchExistingTrainings(group.qualification_type_id, group.users);
      } else {
        toast.warning("Please select users with the same qualification type for adding to existing training");
        return;
      }
    } else {
      // Single certificate
      fetchExistingTrainings(certificate.qualification_type_id, [certificate.user_id]);
    }
  };

  const fetchExistingTrainings = async (qualificationTypeId, userIds) => {
    try {
      const token = localStorage.getItem("access_token");
      const userData = JSON.parse(localStorage.getItem("user") || "{}");
      const companyId = userData.company;
      
      console.log('Fetching existing trainings for qualification type:', qualificationTypeId, 'users:', userIds);
      
      // Pobierz wszystkie treningi w firmie
      const response = await axios.get(`${API_BASE}/trainings/`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { company: companyId }
      });
      
      console.log('All trainings:', response.data);
      
      // Filtruj treningi:
      // 1. Przyszłe (start_date > dzisiaj)
      // 2. Odpowiedni qualification_type
      // 3. Mają wolne miejsca
      const today = new Date();
      const filteredTrainings = response.data.filter(training => {
        const startDate = new Date(training.start_date);
        const hasSpace = !training.availability || (training.users && training.users.length < training.availability);
        const correctQualification = training.training_center_qualification_data?.qualification_type?.qualification_type_data?.id === qualificationTypeId;
        
        console.log('Training check:', {
          name: training.name,
          startDate: startDate,
          isFuture: startDate > today,
          hasSpace: hasSpace,
          correctQualification: correctQualification,
          currentUsers: training.users?.length || 0,
          availability: training.availability
        });
        
        return startDate > today && correctQualification && hasSpace;
      });
      
      console.log('Filtered trainings:', filteredTrainings);
      setExistingTrainings(filteredTrainings);
      setShowExistingTrainingsModal(true);
      
    } catch (error) {
      console.error("Error fetching existing trainings:", error);
      toast.error("Failed to fetch existing trainings");
    }
  };

  const closeExistingTrainingsModal = () => {
    setShowExistingTrainingsModal(false);
    setExistingTrainings([]);
    setSelectedExistingTraining(null);
    setSelectedCertificate(null);
  };

  const addUsersToExistingTraining = async () => {
    if (!selectedExistingTraining) {
      toast.error("Please select a training");
      return;
    }

    try {
      const token = localStorage.getItem("access_token");
      
      // Pobierz użytkowników do dodania
      let usersToAdd = [];
      if (selectedCertificateIds.length > 1) {
        usersToAdd = getSelectedUserIds();
      } else {
        usersToAdd = [selectedCertificate.user_id];
      }

      console.log('Adding users to existing training:', {
        trainingId: selectedExistingTraining.id,
        usersToAdd: usersToAdd,
        currentUsers: selectedExistingTraining.users || []
      });

      // Sprawdź czy mamy wystarczająco miejsca
      const currentUserCount = selectedExistingTraining.users ? selectedExistingTraining.users.length : 0;
      const totalAfterAdd = currentUserCount + usersToAdd.length;
      
      if (selectedExistingTraining.availability && totalAfterAdd > selectedExistingTraining.availability) {
        toast.error(`Not enough space. Training has ${selectedExistingTraining.availability} spots, ${currentUserCount} are taken, you're trying to add ${usersToAdd.length} more.`);
        return;
      }

      // Dodaj użytkowników do szkolenia (aktualizuj training) - unikaj duplikatów
      const currentUsers = selectedExistingTraining.users || [];
      const newUsers = usersToAdd.filter(userId => !currentUsers.includes(userId));
      
      if (newUsers.length === 0) {
        toast.warning("Selected user(s) are already enrolled in this training");
        return;
      }
      
      const updatedUsers = [...currentUsers, ...newUsers];
      
      console.log('Current training object:', selectedExistingTraining);
      console.log('Updated users list:', updatedUsers);
      
      // Przygotuj dane w formacie wymaganym przez backend
      const qualificationId = selectedExistingTraining.training_center_qualification_id || selectedExistingTraining.training_center_qualification;
      const updateData = {
        name: selectedExistingTraining.name,
        training_center_qualification_id: qualificationId,
        training_center_qualification: qualificationId, // Backend oczekuje tego pola
        start_date: selectedExistingTraining.start_date,
        end_date: selectedExistingTraining.end_date,
        description: selectedExistingTraining.description || '',
        required_items: selectedExistingTraining.required_items || '',
        availability: selectedExistingTraining.availability,
        status: selectedExistingTraining.status || 'planned',
        company: selectedExistingTraining.company,
        users: updatedUsers
      };
      
      console.log('Sending update data:', updateData);
      
      await axios.put(`${API_BASE}/trainings/${selectedExistingTraining.id}/`, updateData, {
        headers: { Authorization: `Bearer ${token}` }
      });

      toast.success(`Successfully added ${usersToAdd.length} user(s) to training: ${selectedExistingTraining.name}`);
      fetchCertificates(); // Odśwież dane
      fetchAllTrainings(); // Odśwież listę treningów
      closeExistingTrainingsModal();
      setSelectedCertificateIds([]); // Wyczyść zaznaczenie
      
    } catch (error) {
      console.error("Error adding users to existing training:", error);
      toast.error("Failed to add users to training: " + (error.response?.data?.message || error.message));
    }
  };

  const handleManageCertificates = () => {
    const qualificationTypeId = selectedCertificate?.qualification_type_id;
    const url = `/trainings/management?addNew=true${qualificationTypeId ? `&qualificationTypeId=${qualificationTypeId}` : ''}`;
    window.location.href = url;
  };

  const getFilteredCenters = () => {
    if (!searchTermModal) return availableCenters;
    return availableCenters.filter(center =>
      center.training_center?.name?.toLowerCase().includes(searchTermModal.toLowerCase()) ||
      center.training_center?.address?.toLowerCase().includes(searchTermModal.toLowerCase())
    );
  };

  const handleCenterSelect = (center) => {
    console.log('Selected center:', center);
    setSelectedCenter(center);
    setTrainingDetails({
      ...trainingDetails,
      training: `${selectedCertificate.certificate_name} - ${center.training_center?.name}`,
      centerId: center.training_center?.id,
      trainingId: center.id,
      description: `Renewal training for ${selectedCertificate.certificate_name} at ${center.training_center?.name}`,
      requiredItems: center.required_items || trainingDetails.requiredItems
    });
    setShowDropdown(false);
  };

  const handleScheduleTraining = async () => {
    if (!selectedCertificate || !selectedCenter) {
      toast.error("Please select a training center");
      return;
    }

    try {
      const token = localStorage.getItem("access_token");
      const userData = JSON.parse(localStorage.getItem("user") || "{}");
      const companyId = userData.company;
      
      console.log('Scheduling training with data:', {
        selectedCenter,
        selectedCertificate,
        companyId,
        userData
      });
      
      const startDate = new Date(trainingDetails.trainingDate);
      const [startHours, startMinutes] = trainingDetails.startTime.split(":");
      startDate.setHours(parseInt(startHours), parseInt(startMinutes), 0, 0);

      const endDate = new Date(trainingDetails.trainingDate);
      const [endHours, endMinutes] = trainingDetails.endTime.split(":");
      endDate.setHours(parseInt(endHours), parseInt(endMinutes), 0, 0);

      const userId = selectedCertificate.user_id;
      
      if (selectedUserIds.length > 0) {
        const allUserIds = [...selectedUserIds, userId];
        const uniqueUserIds = [...new Set(allUserIds)];
        
        const promises = uniqueUserIds.map(uid => {
          const trainingData = {
            user_id: uid,
            training_id: selectedCenter.id,
            start_date: startDate.toISOString(),
            end_date: endDate.toISOString(),
            company: companyId,
            description: trainingDetails.description || `Renewal training for ${selectedCertificate.certificate_name}`,
            status: "planned",
            required_items: trainingDetails.requiredItems || "",
          };

          return axios.post(`${API_BASE}/user-training-assignments/`, trainingData, {
            headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
          });
        });

        await Promise.all(promises);
        toast.success(`Training scheduled for ${uniqueUserIds.length} users at ${selectedCenter.training_center?.name}`);
      } else {
        const trainingData = {
          user_id: userId,
          training_id: selectedCenter.id,
          start_date: startDate.toISOString(),
          end_date: endDate.toISOString(),
          company: companyId,
          description: trainingDetails.description || `Renewal training for ${selectedCertificate.certificate_name}`,
          status: "planned",
          required_items: trainingDetails.requiredItems || "",
        };

        console.log('Sending training data:', trainingData);
        
        await axios.post(`${API_BASE}/user-training-assignments/`, trainingData, {
          headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
          });

        toast.success(`Training scheduled successfully at ${selectedCenter.training_center?.name}`);
      }

      fetchCertificates();
      closeModal();
    } catch (error) {
      console.error("Error scheduling training:", error);
      toast.error("Error scheduling training: " + (error.response?.data?.message || error.message));
    }
  };

  const SortIcon = ({ field }) => (
    sortField === field ? (
      sortDirection === 'asc' ? (
        <ChevronUp className="w-4 h-4 text-brand-600" />
      ) : (
        <ChevronDown className="w-4 h-4 text-brand-600" />
      )
    ) : (
      <ChevronDown className="w-4 h-4 text-slate-400" />
    )
  );

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <div className="p-4">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-3xl font-bold text-slate-900">
            Expiring Certificates
          </h1>
          <div className="flex gap-2">
            <Button
              onClick={handleDownloadCertificates}
              disabled={selectedCertificateIds.length === 0}
              className="bg-steel-200 hover:bg-steel-300 text-slate-700 font-medium border-0 shadow-md rounded-xl disabled:bg-steel-100 disabled:text-slate-400 disabled:cursor-not-allowed"
            >
              <Download className="h-4 w-4 mr-2" />
              Download Certificates ({selectedCertificateIds.length})
            </Button>
            <Button
              onClick={() => setShowExportModal(true)}
              className="mr-4 bg-brand-600 hover:bg-brand-700 text-white font-medium border-0 shadow-lg shadow-brand-500/20 rounded-xl"
            >
              <Download className="h-4 w-4 mr-2" />
              Export List
            </Button>
          </div>
        </div>
        <div className="p-4 bg-white rounded-2xl flex flex-col" style={{ height: 'calc(100vh - 90px)' }}>
          <div className="mb-2 flex space-x-4 flex-wrap gap-2">
            <div className="flex-1 relative">
              <input
                type="text"
                placeholder="Search certificates..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1);
                }}
                className="w-full pl-10 pr-4 py-2 border border-steel-300 rounded-xl shadow-sm focus:outline-none focus:ring-1 focus:ring-brand-500 focus:border-brand-500"
              />
              <Search
                size={20}
                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400"
              />
            </div>
            <select
              value={filterOption}
              onChange={(e) => {
                setFilterOption(e.target.value);
                setCurrentPage(1);
              }}
              className="w-48 px-4 py-2 border border-steel-300 rounded-xl shadow-sm focus:outline-none focus:ring-1 focus:ring-brand-500 focus:border-brand-500"
            >
              <option value="all">Any Validity</option>
              <option value="valid">Valid (Not Expired)</option>
              <option value="expired">Expired</option>
              <option value="next30">Expiring in 30 Days</option>
              <option value="next60">Expiring in 60 Days</option>
              <option value="next90">Expiring in 90 Days</option>
            </select>
            
            {/* Training Status Filter */}
            <select
              value={trainingFilter}
              onChange={(e) => {
                setTrainingFilter(e.target.value);
                setCurrentPage(1);
              }}
              className="w-48 px-4 py-2 border border-steel-300 rounded-xl shadow-sm focus:outline-none focus:ring-1 focus:ring-brand-500 focus:border-brand-500"
            >
              <option value="all">All Training Statuses</option>
              <option value="planned">Planned Training</option>
              <option value="not_planned">No Planned Training</option>
            </select>

            {/* Date Range Filter */}
            <div className="flex space-x-2">
              <div className="relative">
                <input
                  type="date"
                  placeholder="Start Date"
                  value={dateRange.startDate}
                  onChange={(e) => {
                    setDateRange(prev => ({ ...prev, startDate: e.target.value }));
                    setCurrentPage(1);
                  }}
                  className="w-36 px-4 py-2 border border-steel-300 rounded-xl shadow-sm focus:outline-none focus:ring-1 focus:ring-brand-500 focus:border-brand-500"
                />
              </div>
              <div className="relative">
                <input
                  type="date"
                  placeholder="End Date"
                  value={dateRange.endDate}
                  onChange={(e) => {
                    setDateRange(prev => ({ ...prev, endDate: e.target.value }));
                    setCurrentPage(1);
                  }}
                  className="w-36 px-4 py-2 border border-steel-300 rounded-xl shadow-sm focus:outline-none focus:ring-1 focus:ring-brand-500 focus:border-brand-500"
                />
              </div>
            </div>

            {/* User Select */}
            <div className="relative user-select-dropdown">
              <div className="w-60 relative">
                <input
                  type="text"
                  placeholder={selectedUsers.length > 0 ? `${selectedUsers.length} users selected` : "Select users..."}
                  value={userSearchTerm}
                  onClick={() => {
                    setUserDropdownOpen(!userDropdownOpen);
                    setCertificateDropdownOpen(false);
                  }}
                  onChange={(e) => {
                    setUserSearchTerm(e.target.value);
                    setUserDropdownOpen(true);
                  }}
                  className="w-full px-4 py-2 border border-steel-300 rounded-xl shadow-sm focus:outline-none focus:ring-1 focus:ring-brand-500 focus:border-brand-500 cursor-pointer"
                />
                {selectedUsers.length > 0 && (
                  <button
                    onClick={() => {
                      setSelectedUsers([]);
                      setUserSearchTerm("");
                      setUserDropdownOpen(false);
                      setCurrentPage(1);
                    }}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-slate-400 hover:text-slate-600"
                  >
                    <X size={16} />
                  </button>
                )}
              </div>
              {userDropdownOpen && (
                <div className="absolute z-20 w-full mt-1 bg-white border border-steel-300 rounded-xl shadow-lg max-h-60 overflow-y-auto">
                  {(() => {
                    const filteredUsers = [...new Set(certificates.map(cert => cert.name))]
                      .filter(name => name.toLowerCase().includes(userSearchTerm.toLowerCase()));
                    const allSelected = filteredUsers.length > 0 && filteredUsers.every(name => selectedUsers.includes(name));
                    
                    return (
                      <>
                        <div
                          className="px-4 py-2 hover:bg-brand-50 cursor-pointer flex items-center border-b border-steel-200 font-medium"
                          onClick={() => {
                            if (allSelected) {
                              setSelectedUsers([]);
                            } else {
                              setSelectedUsers(filteredUsers);
                            }
                            setCurrentPage(1);
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={allSelected}
                            onChange={() => {}}
                            className="mr-3"
                          />
                          Select All ({filteredUsers.length})
                        </div>
                        {filteredUsers.map((name, index) => (
                          <div
                            key={index}
                            className="px-4 py-2 hover:bg-brand-50 cursor-pointer flex items-center"
                            onClick={() => {
                              const newSelection = selectedUsers.includes(name)
                                ? selectedUsers.filter(u => u !== name)
                                : [...selectedUsers, name];
                              setSelectedUsers(newSelection);
                              setCurrentPage(1);
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={selectedUsers.includes(name)}
                              onChange={() => {}}
                              className="mr-3"
                            />
                            {name}
                          </div>
                        ))}
                      </>
                    );
                  })()}
                </div>
              )}
            </div>
            
            {/* Certificate Name Select */}
            <div className="relative certificate-select-dropdown">
              <div className="w-60 relative">
                <input
                  type="text"
                  placeholder={selectedCertificateNames.length > 0 ? `${selectedCertificateNames.length} certificates selected` : "Select certificates..."}
                  value={certificateSearchTerm}
                  onClick={() => {
                    setCertificateDropdownOpen(!certificateDropdownOpen);
                    setUserDropdownOpen(false);
                  }}
                  onChange={(e) => {
                    setCertificateSearchTerm(e.target.value);
                    setCertificateDropdownOpen(true);
                  }}
                  className="w-full px-4 py-2 border border-steel-300 rounded-xl shadow-sm focus:outline-none focus:ring-1 focus:ring-brand-500 focus:border-brand-500 cursor-pointer"
                />
                {selectedCertificateNames.length > 0 && (
                  <button
                    onClick={() => {
                      setSelectedCertificateNames([]);
                      setCertificateSearchTerm("");
                      setCertificateDropdownOpen(false);
                      setCurrentPage(1);
                    }}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-slate-400 hover:text-slate-600"
                  >
                    <X size={16} />
                  </button>
                )}
              </div>
              {certificateDropdownOpen && (
                <div className="absolute z-20 w-full mt-1 bg-white border border-steel-300 rounded-xl shadow-lg max-h-60 overflow-y-auto">
                  {(() => {
                    const filteredCertificates = [...new Set(certificates.map(cert => cert.certificate_name))]
                      .filter(name => name.toLowerCase().includes(certificateSearchTerm.toLowerCase()));
                    const allSelected = filteredCertificates.length > 0 && filteredCertificates.every(name => selectedCertificateNames.includes(name));
                    
                    return (
                      <>
                        <div
                          className="px-4 py-2 hover:bg-brand-50 cursor-pointer flex items-center border-b border-steel-200 font-medium"
                          onClick={() => {
                            if (allSelected) {
                              setSelectedCertificateNames([]);
                            } else {
                              setSelectedCertificateNames(filteredCertificates);
                            }
                            setCurrentPage(1);
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={allSelected}
                            onChange={() => {}}
                            className="mr-3"
                          />
                          Select All ({filteredCertificates.length})
                        </div>
                        {filteredCertificates.map((name, index) => (
                          <div
                            key={index}
                            className="px-4 py-2 hover:bg-brand-50 cursor-pointer flex items-center"
                            onClick={() => {
                              const newSelection = selectedCertificateNames.includes(name)
                                ? selectedCertificateNames.filter(c => c !== name)
                                : [...selectedCertificateNames, name];
                              setSelectedCertificateNames(newSelection);
                              setCurrentPage(1);
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={selectedCertificateNames.includes(name)}
                              onChange={() => {}}
                              className="mr-3"
                            />
                            {name}
                          </div>
                        ))}
                      </>
                    );
                  })()}
                </div>
              )}
            </div>
          </div>

          {error && (
            <div className="bg-red-50 text-red-600 p-4 rounded-xl mb-4">
              {error}
            </div>
          )}
          <div className="flex-1 overflow-y-auto">
            <Table>
              <TableHeader className="sticky top-0 bg-steel-100 border-b-2 border-brand-500 z-10">
                <TableRow>
                  <TableHead className="w-12">
                    <input
                      type="checkbox"
                      checked={filteredCertificates.length > 0 && filteredCertificates.every(cert => selectedCertificateIds.includes(cert.id))}
                      onChange={handleSelectAll}
                      className="cursor-pointer"
                    />
                  </TableHead>
                  <TableHead
                    className="cursor-pointer"
                    onClick={() => handleSort('name')}
                  >
                    <div className="flex items-center gap-2">
                      Name
                      <SortIcon field="name" />
                    </div>
                  </TableHead>
                  <TableHead
                    className="cursor-pointer"
                    onClick={() => handleSort('expiring_date')}
                  >
                    <div className="flex items-center gap-2">
                      Expiring Date
                      <SortIcon field="expiring_date" />
                    </div>
                  </TableHead>
                  <TableHead
                    className="cursor-pointer"
                    onClick={() => handleSort('daysStatus')}
                  >
                    <div className="flex items-center gap-2">
                      Days Status
                      <SortIcon field="daysStatus" />
                    </div>
                  </TableHead>
                  <TableHead
                    className="cursor-pointer"
                    onClick={() => handleSort('certificate_name')}
                  >
                    <div className="flex items-center gap-2">
                      Certificate Name
                      <SortIcon field="certificate_name" />
                    </div>
                  </TableHead>
                  <TableHead
                    className="cursor-pointer"
                    onClick={() => handleSort('training')}
                  >
                    <div className="flex items-center gap-2">
                      Training
                      <SortIcon field="training" />
                    </div>
                  </TableHead>
                  <TableHead className="text-right">Action</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {paginatedCertificates.map((cert) => {
                  const { base, hover } = getRowBackgroundColor(cert.daysStatus);
                  const trainingInfo = getTrainingInfo(cert);
                  return (
                    <TableRow
                      key={cert.id}
                      className={`cursor-pointer ${base} ${hover} transition-colors`}
                      onDoubleClick={() => openModal(cert)}
                    >
                      <TableCell>
                        <input
                          type="checkbox"
                          checked={selectedCertificateIds.includes(cert.id)}
                          onChange={() => handleCheckboxChange(cert.id)}
                          className="cursor-pointer"
                        />
                      </TableCell>
                      <TableCell className="font-medium">{cert.name}</TableCell>
                      <TableCell>{cert.expiring_date}</TableCell>
                      <TableCell>{formatDaysStatus(cert.daysStatus)}</TableCell>
                      <TableCell>{cert.certificate_name}</TableCell>
                      <TableCell 
                        className={`${trainingInfo.startsWith('Scheduled') ? 'text-green-600 font-bold cursor-pointer hover:text-green-700 hover:underline' : ''}`}
                        onClick={trainingInfo.startsWith('Scheduled') ? () => openTrainingDetailsModal(cert) : undefined}
                      >
                        {trainingInfo}
                      </TableCell>
                      <TableCell className="text-right">
                        <div className="flex gap-2 justify-end">
                          <button
                            className="text-brand-600 hover:text-brand-700 hover:bg-brand-50 p-1 rounded-xl transition-colors"
                            onClick={() => openModal(cert)}
                            title="Schedule New Training"
                          >
                            <NotebookPen className="h-5 w-5" />
                          </button>
                          <button
                            className="text-brand-600 hover:text-brand-700 hover:bg-brand-50 p-1 rounded-xl transition-colors"
                            onClick={() => openExistingTrainingsModal(cert)}
                            title="Add to Existing Training"
                          >
                            <UserPlus className="h-5 w-5" />
                          </button>
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
          <div className="flex items-center justify-between mt-6">
            <div className="flex items-center space-x-4">
              <div className="text-sm text-slate-600">
                Showing {(currentPage - 1) * itemsPerPage + 1}-
                {Math.min(currentPage * itemsPerPage, filteredCertificates.length)}{' '}
                of {filteredCertificates.length} items
              </div>
              <select
                value={itemsPerPage}
                onChange={(e) => {
                  setItemsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}
                className="text-sm px-4 py-2 border border-steel-300 rounded-xl shadow-sm focus:outline-none focus:ring-1 focus:ring-brand-500 focus:border-brand-500 min-w-[140px]"
              >
                <option value={5}>5 per page</option>
                <option value={10}>10 per page</option>
                <option value={25}>25 per page</option>
                <option value={50}>50 per page</option>
                <option value={100}>100 per page</option>
              </select>
            </div>
            <div className="flex space-x-2">
              {currentPage > 1 && (
                <button
                  className="px-4 py-2 border border-steel-300 text-slate-700 rounded-xl hover:bg-brand-50 flex items-center justify-center transition-colors"
                  onClick={() => setCurrentPage(currentPage - 1)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-chevron-left h-4 w-4 mr-1"
                  >
                    <path d="m15 18-6-6 6-6" />
                  </svg>
                  Previous
                </button>
              )}
              {getVisiblePages().map((page) => (
                <button
                  key={page}
                  className={`px-4 py-2 border ${
                    page === currentPage
                      ? 'border-brand-500 bg-brand-50 text-brand-700'
                      : 'border-steel-300 text-slate-700'
                  } rounded-xl hover:bg-brand-50 flex items-center justify-center transition-colors`}
                  onClick={() => setCurrentPage(page)}
                >
                  {page}
                </button>
              ))}
              {currentPage < totalPages && (
                <button
                  className="px-4 py-2 border border-steel-300 text-slate-700 rounded-xl hover:bg-brand-50 flex items-center justify-center transition-colors"
                  onClick={() => setCurrentPage(currentPage + 1)}
                >
                  Next
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-chevron-right h-4 w-4 ml-1"
                  >
                    <path d="m9 18 6-6-6-6" />
                  </svg>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Schedule Training Modal */}
      {isModalOpen && selectedCertificate && (
        <div
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
          onClick={closeModal}
        >
          <div
            className="bg-white rounded-2xl p-6 max-w-4xl w-full mx-4 shadow-lg max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-start mb-6">
              <div>
                <h2 className="text-xl font-bold text-slate-900 mb-2">
                  Schedule Renewal Training
                </h2>
                <div className="text-sm text-slate-600 space-y-1">
                  <p><span className="font-medium">User:</span> {selectedCertificate.name}</p>
                  <p><span className="font-medium">Certificate:</span> {selectedCertificate.certificate_name}</p>
                  <p><span className="font-medium">Expires:</span> {selectedCertificate.expiring_date}</p>
                  <p><span className="font-medium">Status:</span> 
                    <span className={`ml-1 ${selectedCertificate.daysStatus < 0 ? 'text-red-600' : selectedCertificate.daysStatus <= 30 ? 'text-orange-600' : 'text-green-600'}`}>
                      {formatDaysStatus(selectedCertificate.daysStatus)}
                    </span>
                  </p>
                </div>
              </div>
              <button onClick={closeModal} className="text-slate-400 hover:text-slate-600">
                <X className="h-6 w-6" />
              </button>
            </div>

            <div className="p-4 border border-brand-200 rounded-xl bg-brand-50">
              <h3 className="text-sm font-medium text-brand-800 mb-3 flex items-center">
                <BookOpen className="h-4 w-4 mr-2" />
                Schedule Renewal Training
              </h3>
              <div className="space-y-4">
                <div className="bg-white p-3 rounded-xl border border-steel-200">
                  <div className="text-sm">
                    <span className="font-medium text-slate-700">Training required for:</span>
                    <div className="mt-1 text-brand-800 font-medium">
                      {selectedCertificate.certificate_name}
                    </div>
                  </div>
                </div>

                <div>
                  <label className="block text-xs text-slate-600 mb-1">
                    Select Training Center
                    <span className="text-xs text-slate-500 ml-1">
                      ({availableCenters.length} available for this qualification)
                    </span>
                  </label>
                  
                  {availableCenters.length > 0 ? (
                    <>
                      <div className="relative mb-2">
                        <input
                          type="text"
                          placeholder="Search training centers..."
                          value={searchTermModal}
                          onChange={(e) => setSearchTermModal(e.target.value)}
                          className="w-full p-2 text-sm border rounded"
                        />
                        <Search className="absolute right-3 top-2.5 h-4 w-4 text-slate-400" />
                      </div>

                      <div className="space-y-2 max-h-60 overflow-y-auto border rounded bg-white p-2">
                        {getFilteredCenters().map((center, idx) => (
                          <div 
                            key={idx}
                            onClick={() => handleCenterSelect(center)}
                            className={`p-3 rounded-xl text-sm cursor-pointer transition-colors border-2 ${
                              selectedCenter?.id === center.id
                                ? "bg-brand-100 border-brand-300"
                                : "hover:bg-steel-50 border-steel-200"
                            }`}
                          >
                            <div className="flex items-start justify-between">
                              <div className="flex-1">
                                <div className="flex items-center">
                                  <div className={`w-4 h-4 rounded-full mr-3 ${
                                    selectedCenter?.id === center.id
                                      ? "bg-brand-500" 
                                      : "border-2 border-steel-400"
                                  }`}></div>
                                  <div>
                                    <div className="font-medium text-slate-900">
                                      {center.training_center?.name || 'Unknown center'}
                                    </div>
                                    {center.training_center?.address && (
                                      <div className="text-xs text-slate-500 mt-1">
                                        📍 {center.training_center.address}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  ) : (
                    <div className="p-4 text-center text-slate-500 border rounded bg-steel-50">
                      <BookOpen className="h-8 w-8 mx-auto mb-2 text-slate-400" />
                      <p>No training centers available for this qualification.</p>
                      <p className="text-xs mt-1">Contact the administrator.</p>
                    </div>
                  )}
                </div>
                
                {selectedCenter && (
                  <div className="bg-steel-50 p-3 rounded-xl border">
                    <label className="block text-xs text-slate-600 mb-2">Users for Training</label>
                    <div className="flex items-center justify-between">
                      <span className="text-sm text-slate-700">
                        {selectedUserIds.length > 0 ? `${selectedUserIds.length + 1} users selected (including ${selectedCertificate.name})` : `Single user (${selectedCertificate.name})`}
                      </span>
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => setShowUserSelectionModal(true)}
                        className="flex items-center"
                      >
                        <Users className="h-4 w-4 mr-1" />
                        {selectedUserIds.length > 0 ? 'Change Users' : 'Select Multiple Users'}
                      </Button>
                    </div>
                    {selectedUserIds.length > 0 && (
                      <div className="mt-2 text-xs text-brand-600">
                        Training will be scheduled for {selectedUserIds.length + 1} users
                      </div>
                    )}
                  </div>
                )}
                
                <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                  <div>
                    <label className="block text-xs text-slate-600 mb-1">Training Date</label>
                    <input
                      type="date"
                      className="w-full p-2 text-sm border rounded"
                      value={trainingDetails.trainingDate.toISOString().split('T')[0]}
                      onChange={(e) => setTrainingDetails(prev => ({ ...prev, trainingDate: new Date(e.target.value) }))}
                    />
                  </div>
                  <div>
                    <label className="block text-xs text-slate-600 mb-1">Start Time</label>
                    <input
                      type="time"
                      className="w-full p-2 text-sm border rounded"
                      value={trainingDetails.startTime}
                      onChange={(e) => setTrainingDetails(prev => ({ ...prev, startTime: e.target.value }))}
                    />
                  </div>
                  <div>
                    <label className="block text-xs text-slate-600 mb-1">End Time</label>
                    <input
                      type="time"
                      className="w-full p-2 text-sm border rounded"
                      value={trainingDetails.endTime}
                      onChange={(e) => setTrainingDetails(prev => ({ ...prev, endTime: e.target.value }))}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div>
                    <label className="block text-xs text-slate-600 mb-1">Description</label>
                    <textarea
                      className="w-full p-2 text-sm border rounded"
                      rows={3}
                      placeholder="Training description..."
                      value={trainingDetails.description}
                      onChange={(e) => setTrainingDetails(prev => ({ ...prev, description: e.target.value }))}
                    />
                  </div>
                  <div>
                    <label className="block text-xs text-slate-600 mb-1">Required Items</label>
                    <textarea
                      className="w-full p-2 text-sm border rounded"
                      rows={3}
                      placeholder="Items to bring to the training..."
                      value={trainingDetails.requiredItems}
                      onChange={(e) => setTrainingDetails(prev => ({ ...prev, requiredItems: e.target.value }))}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-end gap-3 mt-6">
              <Button variant="outline" onClick={closeModal}>
                Cancel
              </Button>
              <Button 
                onClick={handleScheduleTraining}
                disabled={!selectedCenter}
                className="bg-brand-600 hover:bg-brand-700 text-white font-medium border-0 shadow-md disabled:bg-steel-300 disabled:cursor-not-allowed"
              >
                <Calendar className="h-4 w-4 mr-2" />
                Schedule Training
              </Button>
            </div>
          </div>
        </div>
      )}

      <UserSelectionModal
        isOpen={showUserSelectionModal}
        onClose={() => setShowUserSelectionModal(false)}
        onConfirm={(userIds) => {
          console.log("UserSelectionModal onConfirm called with userIds:", userIds);
          setSelectedUserIds(userIds);
          setShowUserSelectionModal(false);
        }}
        currentUserId={selectedCertificate?.user_id}
      />

      {showNoTrainingModal && selectedCertificate && (
        <div
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
          onClick={closeModal}
        >
          <div
            className="bg-white rounded-xl p-6 max-w-md w-full mx-4 shadow-xl border"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100 mb-4">
                <BookOpen className="h-6 w-6 text-yellow-600" />
              </div>
              
              <h3 className="text-lg font-medium text-slate-900 mb-2">
                No Training Available
              </h3>
              
              <div className="text-sm text-slate-600 mb-6 space-y-2">
                <p>
                  No training centers available in the system for the certificate:
                </p>
                <p className="font-semibold text-slate-800">
                  {selectedCertificate.certificate_name}
                </p>
                <p className="mt-3">
                  Would you like to add training details to the system?
                </p>
              </div>
            </div>
            
            <div className="flex justify-center gap-3">
              <Button 
                variant="outline" 
                onClick={closeModal}
                className="px-6 py-2"
              >
                No
              </Button>
              <Button 
                onClick={handleManageCertificates}
                className="px-6 py-2 bg-brand-600 hover:bg-brand-700 text-white"
              >
                Yes
              </Button>
            </div>
          </div>
        </div>
      )}


      {showExportModal && (
        <div
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
          onClick={() => setShowExportModal(false)}
        >
          <div
            className="bg-white rounded-xl p-6 max-w-6xl w-full mx-4 shadow-lg max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-start mb-6">
              <div>
                <h2 className="text-xl font-bold text-slate-900 mb-2">
                  Export User List
                </h2>
                <p className="text-sm text-slate-600">
                  Users meeting the current filtering criteria with certificate expiration dates
                </p>
              </div>
              <button onClick={() => setShowExportModal(false)} className="text-slate-400 hover:text-slate-600">
                <X className="h-6 w-6" />
              </button>
            </div>

            <div className="border rounded-xl p-4 bg-steel-50 mb-6">
              <div className="mb-4">
                <h3 className="text-sm font-medium text-slate-700 mb-2">
                  Filtered Users ({(() => {
                    const uniqueUsers = [...new Set(filteredCertificates.map(cert => cert.name))];
                    return uniqueUsers.length;
                  })()})
                </h3>
                <div className="max-h-96 overflow-y-auto bg-white rounded border">
                  <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                      <thead className="bg-steel-50 sticky top-0">
                        <tr>
                          <th className="px-4 py-2 text-left font-medium text-slate-700 border-b">User Name</th>
                          {selectedCertificateNames.length > 0 ? 
                            selectedCertificateNames.map(certName => (
                              <th key={certName} className="px-4 py-2 text-left font-medium text-slate-700 border-b min-w-32">
                                {certName}
                              </th>
                            )) : 
                            [...new Set(filteredCertificates.map(cert => cert.certificate_name))].map(certName => (
                              <th key={certName} className="px-4 py-2 text-left font-medium text-slate-700 border-b min-w-32">
                                {certName}
                              </th>
                            ))
                          }
                        </tr>
                      </thead>
                      <tbody>
                        {(() => {
                          const uniqueUsers = [...new Set(filteredCertificates.map(cert => cert.name))];
                          const certificateNames = selectedCertificateNames.length > 0 ? 
                            selectedCertificateNames : 
                            [...new Set(filteredCertificates.map(cert => cert.certificate_name))];
                          
                          return uniqueUsers.sort().map((userName, index) => {
                            const userCerts = filteredCertificates.filter(cert => cert.name === userName);
                            
                            return (
                              <tr key={index} className="hover:bg-steel-50">
                                <td className="px-4 py-2 border-b font-medium">{userName}</td>
                                {certificateNames.map(certName => {
                                  const cert = userCerts.find(c => c.certificate_name === certName);
                                  return (
                                    <td key={certName} className="px-4 py-2 border-b">
                                      {cert ? (
                                        <div className="flex flex-col">
                                          <span className="text-xs text-slate-600">{cert.expiring_date}</span>
                                          <span className={`text-xs ${
                                            cert.daysStatus === null ? 'text-slate-500' :
                                            cert.daysStatus < 0 ? 'text-red-600' :
                                            cert.daysStatus <= 30 ? 'text-orange-600' :
                                            'text-green-600'
                                          }`}>
                                            {cert.daysStatus === null ? 'N/A' :
                                             cert.daysStatus < 0 ? `Expired ${Math.abs(cert.daysStatus)} days ago` :
                                             cert.daysStatus === 0 ? 'Expires today' :
                                             `Expires in ${cert.daysStatus} days`}
                                          </span>
                                        </div>
                                      ) : (
                                        <span className="text-slate-400 text-xs">Not found</span>
                                      )}
                                    </td>
                                  );
                                })}
                              </tr>
                            );
                          });
                        })()}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div className="border rounded-xl p-4 bg-brand-50 mb-6">
              <h3 className="text-sm font-medium text-brand-800 mb-3">Export Options</h3>
              <div className="space-y-3">
                <Button
                  onClick={() => {
                    const uniqueUsers = [...new Set(filteredCertificates.map(cert => cert.name))];
                    const certificateNames = selectedCertificateNames.length > 0 ? 
                      selectedCertificateNames : 
                      [...new Set(filteredCertificates.map(cert => cert.certificate_name))];
                    
                    let csvContent = "data:text/csv;charset=utf-8,";
                    csvContent += "User Name," + certificateNames.join(",") + "\n";
                    
                    uniqueUsers.sort().forEach(userName => {
                      const userCerts = filteredCertificates.filter(cert => cert.name === userName);
                      let row = `"${userName}",`;
                      
                      certificateNames.forEach(certName => {
                        const cert = userCerts.find(c => c.certificate_name === certName);
                        if (cert) {
                          row += `"${cert.expiring_date}",`;
                        } else {
                          row += '"Not found",';
                        }
                      });
                      
                      csvContent += row.slice(0, -1) + "\n";
                    });
                    
                    const encodedUri = encodeURI(csvContent);
                    const link = document.createElement("a");
                    link.setAttribute("href", encodedUri);
                    link.setAttribute("download", `certificates_export_${new Date().toISOString().split('T')[0]}.csv`);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    toast.success("User and certificate list exported successfully!");
                  }}
                  className="w-full bg-green-600 hover:bg-green-700 text-white"
                >
                  <Download className="h-4 w-4 mr-2" />
                  Export as CSV
                </Button>
                
                <Button
                  onClick={() => {
                    const uniqueUsers = [...new Set(filteredCertificates.map(cert => cert.name))];
                    const certificateNames = selectedCertificateNames.length > 0 ? 
                      selectedCertificateNames : 
                      [...new Set(filteredCertificates.map(cert => cert.certificate_name))];
                    
                    let textContent = "User Name\t" + certificateNames.join("\t") + "\n";
                    
                    uniqueUsers.sort().forEach(userName => {
                      const userCerts = filteredCertificates.filter(cert => cert.name === userName);
                      let row = userName + "\t";
                      
                      certificateNames.forEach(certName => {
                        const cert = userCerts.find(c => c.certificate_name === certName);
                        if (cert) {
                          row += cert.expiring_date + "\t";
                        } else {
                          row += "Not found\t";
                        }
                      });
                      
                      textContent += row.slice(0, -1) + "\n";
                    });
                    
                    const blob = new Blob([textContent], { type: 'text/plain' });
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.setAttribute("href", url);
                    link.setAttribute("download", `certificates_export_${new Date().toISOString().split('T')[0]}.txt`);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
                    toast.success("User and certificate list exported successfully!");
                  }}
                  className="w-full bg-steel-600 hover:bg-steel-700 text-white rounded-xl"
                >
                  <Download className="h-4 w-4 mr-2" />
                  Export as TXT
                </Button>

                <Button
                  onClick={() => {
                    const uniqueUsers = [...new Set(filteredCertificates.map(cert => cert.name))];
                    const certificateNames = selectedCertificateNames.length > 0 ? 
                      selectedCertificateNames : 
                      [...new Set(filteredCertificates.map(cert => cert.certificate_name))];
                    
                    let textContent = "User Name\t" + certificateNames.join("\t") + "\n";
                    
                    uniqueUsers.sort().forEach(userName => {
                      const userCerts = filteredCertificates.filter(cert => cert.name === userName);
                      let row = userName + "\t";
                      
                      certificateNames.forEach(certName => {
                        const cert = userCerts.find(c => c.certificate_name === certName);
                        if (cert) {
                          row += cert.expiring_date + "\t";
                        } else {
                          row += "Not found\t";
                        }
                      });
                      
                      textContent += row.slice(0, -1) + "\n";
                    });
                    
                    navigator.clipboard.writeText(textContent).then(() => {
                      toast.success("User and certificate table copied to clipboard!");
                    }).catch(() => {
                      toast.error("Failed to copy to clipboard");
                    });
                  }}
                  className="w-full bg-brand-600 hover:bg-brand-700 text-white"
                >
                  <Clock className="h-4 w-4 mr-2" />
                  Copy to Clipboard
                </Button>
              </div>
            </div>

            <div className="text-sm text-slate-600 mb-4">
              <h4 className="font-medium mb-2">Active Filters:</h4>
              <ul className="space-y-1">
                <li>• Filter: {filterOption === 'all' ? 'All Certificates' : filterOption}</li>
                {selectedUsers.length > 0 && <li>• Selected Users: {selectedUsers.length}</li>}
                {selectedCertificateNames.length > 0 && <li>• Selected Certificates: {selectedCertificateNames.length}</li>}
                {searchTerm && <li>• Search Term: "{searchTerm}"</li>}
                {trainingFilter !== 'all' && <li>• Training Status: {trainingFilter === 'planned' ? 'Planned' : 'No Planned Training'}</li>}
                {(dateRange.startDate || dateRange.endDate) && (
                  <li>
                    • Date Range: 
                    {dateRange.startDate && ` from ${dateRange.startDate}`}
                    {dateRange.endDate && ` to ${dateRange.endDate}`}
                  </li>
                )}
              </ul>
            </div>

            <div className="flex justify-end gap-3">
              <Button variant="outline" onClick={() => setShowExportModal(false)}>
                Close
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Multiple Trainings Confirmation Modal */}
      {showMultipleTrainingsModal && (
        <div
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
          onClick={cancelMultipleTrainings}
        >
          <div
            className="bg-white rounded-xl p-6 max-w-2xl w-full mx-4 shadow-xl border"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100 mb-4">
                <Users className="h-6 w-6 text-yellow-600" />
              </div>
              
              <h3 className="text-lg font-medium text-slate-900 mb-2">
                Multiple Training Types Required
              </h3>
              
              <div className="text-sm text-slate-600 mb-6">
                <p className="mb-4">
                  Selected entries require more than one type of training. 
                  Do you want to create <strong>{trainingGroups.length} separate trainings</strong>?
                </p>
                
                <div className="text-left bg-steel-50 rounded-xl p-4 max-h-60 overflow-y-auto">
                  <h4 className="font-medium text-slate-800 mb-3">Training groups to be created:</h4>
                  {trainingGroups.map((group, index) => (
                    <div key={index} className="mb-3 p-3 bg-white rounded border">
                      <div className="flex items-center justify-between mb-2">
                        <span className="font-medium text-brand-800">
                          Training {index + 1}: {group.certificate_name}
                        </span>
                        <span className="text-sm text-slate-500">
                          {group.users.length} user{group.users.length !== 1 ? 's' : ''}
                        </span>
                      </div>
                      {group.trainingNumber && (
                        <div className="text-xs text-slate-600">
                          Training No: {group.trainingNumber}
                        </div>
                      )}
                      <div className="text-xs text-slate-600">
                        Available centers: {group.centers.length}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            
            <div className="flex justify-center gap-3">
              <Button 
                variant="outline" 
                onClick={cancelMultipleTrainings}
                className="px-6 py-2"
              >
                Cancel
              </Button>
              <Button 
                onClick={startMultipleTrainings}
                className="px-6 py-2 bg-brand-600 hover:bg-brand-700 text-white"
              >
                Yes, Create {trainingGroups.length} Trainings
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Existing Trainings Modal */}
      {showExistingTrainingsModal && (
        <div
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
          onClick={closeExistingTrainingsModal}
        >
          <div
            className="bg-white rounded-xl p-6 max-w-4xl w-full mx-4 shadow-lg max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-start mb-6">
              <div>
                <h2 className="text-xl font-bold text-slate-900 mb-2">
                  Add to Existing Training
                </h2>
                <div className="text-sm text-slate-600 space-y-1">
                  <p><span className="font-medium">Certificate:</span> {selectedCertificate?.certificate_name}</p>
                  <p><span className="font-medium">Users to add:</span> {selectedCertificateIds.length > 1 ? `${getSelectedUserIds().length} users` : selectedCertificate?.name}</p>
                </div>
              </div>
              <button onClick={closeExistingTrainingsModal} className="text-slate-400 hover:text-slate-600">
                <X className="h-6 w-6" />
              </button>
            </div>

            {existingTrainings.length > 0 ? (
              <div>
                <div className="p-4 border border-brand-200 rounded-xl bg-brand-50 mb-4">
                  <h3 className="text-sm font-medium text-brand-800 mb-3 flex items-center">
                    <Users className="h-4 w-4 mr-2" />
                    Available Future Trainings ({existingTrainings.length})
                  </h3>
                  <p className="text-sm text-brand-700">
                    Select a training to add the selected user(s). Only trainings with matching qualification type and available spots are shown.
                  </p>
                </div>

                <div className="space-y-3 max-h-96 overflow-y-auto">
                  {existingTrainings.map((training) => {
                    const startDate = new Date(training.start_date);
                    const endDate = new Date(training.end_date);
                    const currentUsers = training.users?.length || 0;
                    const availableSpots = training.availability ? training.availability - currentUsers : 'Unlimited';
                    const usersToAdd = selectedCertificateIds.length > 1 ? getSelectedUserIds().length : 1;
                    
                    return (
                      <div
                        key={training.id}
                        onClick={() => setSelectedExistingTraining(training)}
                        className={`p-4 rounded-xl border-2 cursor-pointer transition-colors ${
                          selectedExistingTraining?.id === training.id
                            ? "bg-brand-100 border-brand-300"
                            : "hover:bg-steel-50 border-steel-200"
                        }`}
                      >
                        <div className="flex items-start justify-between">
                          <div className="flex-1">
                            <div className="flex items-center">
                              <div className={`w-4 h-4 rounded-full mr-3 ${
                                selectedExistingTraining?.id === training.id
                                  ? "bg-brand-500" 
                                  : "border-2 border-steel-400"
                              }`}></div>
                              <div>
                                <div className="font-medium text-slate-900">
                                  {training.name}
                                </div>
                                <div className="text-sm text-slate-600 mt-1">
                                  {training.training_center_qualification_data?.training_center?.name}
                                </div>
                              </div>
                            </div>
                            
                            <div className="ml-7 mt-3 grid grid-cols-2 gap-4 text-sm">
                              <div>
                                <span className="font-medium text-slate-700">Start:</span>
                                <div className="text-brand-800">
                                  {startDate.toLocaleDateString('en-US', {
                                    year: 'numeric',
                                    month: 'short',
                                    day: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit'
                                  })}
                                </div>
                              </div>
                              <div>
                                <span className="font-medium text-slate-700">End:</span>
                                <div className="text-brand-800">
                                  {endDate.toLocaleDateString('en-US', {
                                    year: 'numeric',
                                    month: 'short',
                                    day: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit'
                                  })}
                                </div>
                              </div>
                              <div>
                                <span className="font-medium text-slate-700">Current participants:</span>
                                <div className="text-slate-800">{currentUsers}</div>
                              </div>
                              <div>
                                <span className="font-medium text-slate-700">Available spots:</span>
                                <div className={`${typeof availableSpots === 'number' && availableSpots < usersToAdd ? 'text-red-600' : 'text-green-600'}`}>
                                  {availableSpots}
                                </div>
                              </div>
                            </div>

                            {training.description && (
                              <div className="ml-7 mt-2">
                                <span className="font-medium text-slate-700 text-sm">Description:</span>
                                <div className="text-sm text-slate-600 mt-1">{training.description}</div>
                              </div>
                            )}
                          </div>
                          
                          <div className="text-right ml-4">
                            <div className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                              training.status === 'planned' ? 'bg-yellow-100 text-yellow-800' :
                              training.status === 'approved' ? 'bg-green-100 text-green-800' :
                              'bg-steel-100 text-slate-800'
                            }`}>
                              {training.status?.charAt(0).toUpperCase() + training.status?.slice(1) || 'Unknown'}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className="flex justify-end gap-3 mt-6">
                  <Button variant="outline" onClick={closeExistingTrainingsModal}>
                    Cancel
                  </Button>
                  <Button 
                    onClick={addUsersToExistingTraining}
                    disabled={!selectedExistingTraining}
                    className="bg-green-600 hover:bg-green-700 text-white font-medium border-0 shadow-md disabled:bg-steel-300 disabled:cursor-not-allowed"
                  >
                    <UserPlus className="h-4 w-4 mr-2" />
                    Add to Selected Training
                  </Button>
                </div>
              </div>
            ) : (
              <div className="text-center py-8">
                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-steel-100 mb-4">
                  <BookOpen className="h-6 w-6 text-slate-400" />
                </div>
                <h3 className="text-lg font-medium text-slate-900 mb-2">
                  No Available Trainings
                </h3>
                <p className="text-sm text-slate-600 mb-4">
                  No future trainings found with matching qualification type and available spots.
                </p>
                <Button 
                  onClick={() => {
                    closeExistingTrainingsModal();
                    openModal(selectedCertificate);
                  }}
                  className="bg-brand-600 hover:bg-brand-700 text-white"
                >
                  Schedule New Training Instead
                </Button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Training Edit Modal */}
      <TrainingEditModal
        isOpen={showTrainingEditModal}
        onClose={closeTrainingEditModal}
        trainingData={trainingEditData}
        fetchData={handleTrainingEditSuccess}
      />
    </div>
  );
};

export default CertificateExp;